"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LayoutEmployee = exports.LayoutDepartment = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _queryString = _interopRequireDefault(require("query-string"));
var _pageContext = _interopRequireDefault(require("../../context/pageContext"));
var _department = _interopRequireDefault(require("./department"));
var _employee = _interopRequireDefault(require("./employee"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Layout = _ref => {
  let {
    children,
    title
  } = _ref;
  const [pageData, setPageData] = (0, _react.useContext)(_pageContext.default);
  (0, _react.useEffect)(() => {
    var _pageData$data;
    if ((pageData === null || pageData === void 0 || (_pageData$data = pageData.data) === null || _pageData$data === void 0 || (_pageData$data = _pageData$data.meta) === null || _pageData$data === void 0 ? void 0 : _pageData$data.title) === title) {
      return;
    }
    const additionalPageData = {
      ...pageData
    };
    additionalPageData.data = {
      ...pageData.data,
      meta: {
        title: title
      }
    };
    setPageData(additionalPageData);
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children);
};
const LayoutDepartment = _ref2 => {
  var _queryString$parse$pr, _queryString$parse;
  let {
    match,
    location
  } = _ref2;
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    id: departmentID,
    lang
  } = match.params;
  const {
    search
  } = location;
  const [providers] = (0, _react.useState)((_queryString$parse$pr = (_queryString$parse = _queryString.default.parse(search)) === null || _queryString$parse === void 0 ? void 0 : _queryString$parse.providers) !== null && _queryString$parse$pr !== void 0 ? _queryString$parse$pr : "");
  return /*#__PURE__*/_react.default.createElement(Layout, {
    title: t("site.team.pageTitle")
  }, /*#__PURE__*/_react.default.createElement(_department.default, {
    departmentID: departmentID,
    lang: lang,
    providers: providers
  }));
};
exports.LayoutDepartment = LayoutDepartment;
const LayoutEmployee = _ref3 => {
  let {
    match
  } = _ref3;
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    lang
  } = match.params;
  return /*#__PURE__*/_react.default.createElement(Layout, {
    title: t("site.team.pageTitle")
  }, /*#__PURE__*/_react.default.createElement(_employee.default, {
    lang: lang
  }));
};
exports.LayoutEmployee = LayoutEmployee;